/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

export const summaryJSX = (selectedReviewType, friendReviewersArray, selectedReviewerProfile) => {
  return (
    <Box
      sx={{
        my: 1,
        p: 2,
        backgroundColor: 'whitesmoke',
        width: '100%',
        boxShadow: 3,
        borderRadius: '5px',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      {/* Title, Advisory */}
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: '18',
        }}
      >
        Summary
      </Typography>

      {/* Payment Summary (Product Purchased, Price) */}
      <Box
        sx={{
          my: 1,
          p: 2,
          width: '95%',
          backgroundColor: 'white',
          borderRadius: 3,
          border: 2,
          borderColor: 'black',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          <Typography>
            {/* TK */}
            {selectedReviewType.type === 'Friend' ? 
              `${friendReviewersArray.length} x friend review`
              :
              `1 ${selectedReviewType.type} Review by ${selectedReviewerProfile.bio.vitalInfo.firstName}`
            }
          </Typography>
          <Typography>
            {/* TK */}
            {selectedReviewType.type === 'Friend' ? 
              `$${selectedReviewType.price * friendReviewersArray.length}`
              :
              `$${selectedReviewType.type === 'Expert' ? selectedReviewerProfile.reviewRate : selectedReviewType.price}`
            }
          </Typography>
        </Box>

      </Box>
    </Box>
  )
}